import * as React from 'react';

import styles from './styles.module.scss';
import TimeSheetNote from '../TimeSheetRow/TimeSheetNote';
import TimeSheetTime from '../TimeSheetRow/TimeSheetTime';

interface OwnProps {
	endTime: Nullable<string>;
	startTime: Nullable<string>;
	totalTime: number;
	note: Nullable<string>;
	showNoteModal: () => void;
}

type Props = OwnProps;

const OriginalShiftTime: React.FC<Props> = (props) => {
	const {
		endTime,
		startTime,
		totalTime,
		note,
		showNoteModal,
	} = props;

	return (
		<div className={styles['original-time-container']}>
			<div className={styles['original-time-header']}>
				ORIGINAL SHIFT TIME
			</div>
			<TimeSheetTime
				endTime={endTime}
				startTime={startTime}
				timeZoneOffset={0}
				totalTime={totalTime}
				workShifts={[]}
			/>
			{note &&
				<TimeSheetNote
					note={note}
					openNoteModal={showNoteModal}
					showNoteActionButton={false}
				/>
			}
		</div>
	);
};

export default OriginalShiftTime;
